import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerTelefoneAktualisierenAdmin laden';
export const POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerTelefoneAktualisierenAdmin ausführen';
export const POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerTelefoneAktualisierenAdmin laden erfolgreich';
export const POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerTelefoneAktualisierenAdmin Ladefehler';
export const POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerTelefoneAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerTelefoneAktualisierenAdminAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN;
        constructor(public benutzerTelefoneAktualisierenRequest: api.BenutzerTelefoneAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefoneAktualisierenRequest: api.BenutzerTelefoneAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefoneAktualisierenRequest: api.BenutzerTelefoneAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefoneAktualisierenRequest: api.BenutzerTelefoneAktualisierenRequest, public optPayload: any = null) {}
    }
export class PostBenutzerTelefoneAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_TELEFONE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerTelefoneAktualisierenAdminActions =
    PostBenutzerTelefoneAktualisierenAdminAction
    | PostBenutzerTelefoneAktualisierenAdminAusfuehrenAction
    | PostBenutzerTelefoneAktualisierenAdminErfolgreichAction
    | PostBenutzerTelefoneAktualisierenAdminFehlerAction
    | PostBenutzerTelefoneAktualisierenAdminNichtAusgefuehrtAction
    ;
